import { Box, Typography } from "@mui/material";
import { alpha, type Theme } from "@mui/material/styles";
import type { HTMLAttributes } from "react";
import { getOptionLabelOfUserOrEmailMapping } from "../../../utils/type/type.utils";
import { UserOrEmailMapping } from "../typings/admin.types";

/** One row in the colleague suggestion menu. */
type DepartmentUserSuggestionOptionProps = {
  /** Props MUI applies to the option row, without React's key. */
  optionProps: HTMLAttributes<HTMLLIElement>;
  /** Colleague offered by the search. */
  option: UserOrEmailMapping;
  /** True when this colleague is already in the department. */
  assigned: boolean;
};

const assignedOptionSx = {
  "&&": {
    backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.16)
  },
  "&&.Mui-focused": {
    backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.24)
  }
};

/**
 * Suggestion row. Colleagues already in the department keep a tinted background
 * so they read as selected next to people who can still be added.
 */
export function DepartmentUserSuggestionOption({
  optionProps,
  option,
  assigned
}: Readonly<DepartmentUserSuggestionOptionProps>) {
  return (
    <Box
      component="li"
      {...optionProps}
      aria-selected={assigned}
      sx={assigned ? assignedOptionSx : undefined}
    >
      <Typography component="span" noWrap sx={{ flex: "1 1 auto", minWidth: 0 }}>
        {getOptionLabelOfUserOrEmailMapping(option, true)}
      </Typography>
    </Box>
  );
}
